import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

import * as colors from '../../../styles/colors';

const initialState = {
  byId: {},
  activeById: {}
};

const users = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUser(state, action) {
      const { user } = action.payload;
      state = _updateUser({ user, state });
    },
    setUsers(state, action) {
      const { users } = action.payload;
      for(const user of users) {
        state = _updateUser({ user, state });
      }
    }
  }
});

const _updateUser = ({user, state}) => {
  const formattedUser = _formatUser(user);
  if (
    !state.byId[user.userId] || 
    user.updatedAt > state.byId[user.userId].updatedAt
  ) {
    state.byId[user.userId] = formattedUser;
    if (!user.isDeleted) {
      state.activeById[user.userId] = formattedUser;
    } else {
      delete state.activeById[user.userId];
    }
  }
  return state;
}

const _formatUser = user => {
  const formattedUser = { ...user };

  formattedUser.location = {
    latitude: user.coordinates.lat,
    longitude: user.coordinates.lng
  };

  formattedUser.timeString = _getTimeString(user.updatedAt);

  formattedUser.style = {
    color: colors.markers.user.DEFAULT,
    zIndex: 99
  };

  return formattedUser;
};

const _getTimeString = timestamp => {
  if (Math.abs(moment().diff(timestamp)) < 60000) {
    return 'just now';
  }
  return moment(timestamp).fromNow();
};

export const {
  setUser,
  setUsers
} = users.actions;

export default users.reducer;